module.exports = __webpack_public_path__ + "img/chara01.8877a09b.png";